import isEmpty from "lodash/isEmpty";

import type { LocationImage } from "../models/LocationImage";

export function getPrimaryLocationImage(images: LocationImage[]) {
  if (isEmpty(images)) {
    return "";
  }
  const imageMarketAsPrimary = images.find((image) => image.isFirst);

  if (imageMarketAsPrimary) {
    return imageMarketAsPrimary.url;
  }

  return images.sort((a, b) => a.order - b.order)[0].url;
}
